import { gql, useQuery } from '@apollo/client'
import { useMemo } from 'react'

const OPERATION_SSID_STATS = gql`
  query cmtSsidStats($id: ID!, $scale: String) {
    stats: cmtSsidStats(id: $id, scale: $scale) {
      connected_devices
      total_consumption
      avg_consumption_per_device
      consumption_graph {
        date
        value
      }
      devices_graph {
        date
        value
      }
      is_upcoming
    }
  }
`

export const useSsidStats = (ssidId: string, scale: 'day' | 'month' = 'day') => {
  const { loading, data, error } = useQuery(OPERATION_SSID_STATS, {
    variables: { id: ssidId, scale },
    skip: !ssidId,
    fetchPolicy: 'network-only'
  })

  const stats = useMemo(() => {
    if (!data?.stats) return null
    return data.stats
  }, [data])

  return {
    loading,
    error: error?.message || null,
    stats
  }
}

export default useSsidStats